



















































import { Component } from 'vue-property-decorator';
import SettingMixin from '@/components/ViewComponent/Setting/setting.mixin';

@Component<Point>({})
export default class Point extends SettingMixin {
  handleChangePoint(index, val) {
    const dataTemp = this.userData.defaultGiftPoint;
    dataTemp[index - 1] = Number(val);
    this.userData.defaultGiftPoint = [...dataTemp];
  }
}
